import { useEffect } from 'react'
import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/cases/Case'
import { caseStudyItems } from 'components/cases/Case/CaseStudyItem'

const CasesPage: React.FC<{ pageId: number }> = ({ pageId }) => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])

  return (
    <>
      <CustomHead
        keyword="事例 実績 クラウドネイティブ AI駆動開発 デザインシステム UX/UIデザイン モダンスタック CI/CD DevOps AIエージェント"
        image="https://www.i3design.jp/ogp_logo.png"
        url={`https://www.i3design.jp/cases/page/${pageId}/`}
        title={`事例 | ページ ${pageId} | i3DESIGN アイスリーデザイン`}
        description="実績一覧。Digital Innovatorとして、クラウドネイティブ、AI駆動開発、デザインシステムに精通した様々な支援実績がございます。UX/UIデザイン、モダンスタック技術、CI/CD、DevOps環境、AIエージェントをフル活用した開発スタイルで顧客のデジタルシフトを支援します。"
      />
      <Template pageId={pageId} />
    </>
  )
}

export async function getStaticPaths() {
  const totalItems = caseStudyItems.length
  const pageSize = 10
  const totalPages = Math.ceil(totalItems / pageSize)

  const paths = Array.from({ length: totalPages }, (_, i) => ({
    params: { id: (i + 1).toString() },
  }))

  return { paths, fallback: false }
}

export async function getStaticProps({ params }) {
  const pageId = parseInt(params.id, 10)

  return {
    props: { pageId },
  }
}

export default CasesPage
